<template>
  <div class="cost-mapping-form text-left">
    <p class="text-lg font-bold mb-6">Tambahkan Cost</p>
    <div class="flex flex-col">
      <div class="mb-6 relative">
        <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Kota Asal</label>
        <div class="relative">
          <TextField withIcon type="text" @input="searchCity($event, 'origin')" v-model="originSearch" placeholder="Pilih kota asal" :disabled="isEditMode" />
          <div class="absolute left-3 top-1/2 transform -translate-y-1/2">
            <Search />
          </div>
          <img src="@/assets/images/rolling.gif" class="w-8 absolute top-1/2 transform -translate-y-1/2 right-2" v-if="isSearching['origin']" />
          <transition name="fade" mode="out-in">
            <div class="mt-1 z-10 border rounded-lg absolute top-full left-0 w-full bg-white" v-if="visibleSuggestion['origin']">
              <ul v-if="cities" class="max-h-40 overflow-y-scroll">
                <li class="cursor-pointer px-3 py-2 hover:bg-neutral-300 " v-for="(city, index) in cities" :key="'city-' + index" @click="selectCity(city, 'origin')">
                  {{ city.village }}, {{ city.area_display }}
                </li>
              </ul>
              <div class="py-4 text-center" v-else>
                Maaf data tidak ditemukan!
              </div>
            </div>
          </transition>
        </div>
        <transition name="fade" mode="out-in">
          <div class="text-system-error text-left mt-1 text-sm" v-if="errors['origin_city']">{{ errors['origin_city'] }}</div>
        </transition>
      </div>
      <div class="mb-6 text-left relative">
        <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Kota Tujuan</label>
        <div class="relative">
          <TextField withIcon type="text" @input="searchCity($event, 'destination')" v-model="destinationSearch" :disabled="isEditMode" placeholder="Pilih kota tujuan" />
          <div class="absolute left-3 top-1/2 transform -translate-y-1/2">
            <Search />
          </div>
          <img src="@/assets/images/rolling.gif" class="w-8 absolute top-1/2 transform -translate-y-1/2 right-2" v-if="isSearching['destination']" />
          <transition name="fade" mode="out-in">
            <div class="mt-1 z-10 border rounded-lg absolute top-full left-0 w-full bg-white" v-if="visibleSuggestion['destination']">
              <ul v-if="cities" class="max-h-40 overflow-y-scroll">
                <li class="cursor-pointer px-3 py-2 hover:bg-neutral-300 " v-for="(city, index) in cities" :key="'city-' + index" @click="selectCity(city, 'destination')">
                  {{ city.village }}, {{ city.area_display }}
                </li>
              </ul>
              <div class="py-4 text-center" v-else>
                Maaf data tidak ditemukan!
              </div>
            </div>
          </transition>
        </div>
        <transition name="fade" mode="out-in">
          <div class="text-system-error text-left mt-1 text-sm" v-if="errors['destination_city']">{{ errors['destination_city'] }}</div>
        </transition>
      </div>
      <div class="mb-6">
        <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Harga Per 1 Kg</label>
        <div class="relative">
          <TextField type="number" withIcon v-model.number="payloads.cost_per_weight" placeholder="Harga dalam satuan rupiah" />
          <div class="absolute left-3 top-1/2 transform -translate-y-1/2">
            Rp
          </div>
        </div>
        <transition name="fade" mode="out-in">
          <div class="text-system-error text-left mt-1 text-sm" v-if="errors['cost_per_weight']">{{ errors['cost_per_weight'] }}</div>
        </transition>
      </div>
      <div class="mb-6">
        <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Komponen Harga</label>
        <div class="relative">
          <TextField type="number" withIcon v-model.number="payloads.base_cost" placeholder="Harga dalam satuan rupiah" />
          <div class="absolute left-3 top-1/2 transform -translate-y-1/2">
            Rp
          </div>
        </div>
        <span class="text-xs text-gray-500 leading-tight inline-block mt-1">Pembagi berat vol matrix, (PxLxT / Nilai di atas)</span>
        <transition name="fade" mode="out-in">
          <div class="text-system-error text-left mt-1 text-sm" v-if="errors['base_cost']">{{ errors['base_cost'] }}</div>
        </transition>
      </div>
      <div class="mb-6">
        <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Harga Dimensi Kecil</label>
        <div class="relative">
          <TextField type="number" withIcon v-model.number="payloads.cost_volume_small" placeholder="Harga dalam satuan rupiah" />
          <div class="absolute left-3 top-1/2 transform -translate-y-1/2">
            Rp
          </div>
        </div>
        <span class="text-xs text-gray-500 leading-tight inline-block mt-1">Ukuran yang telah ditetapkan yaitu : 20x20x8 cm</span>
        <transition name="fade" mode="out-in">
          <div class="text-system-error text-left mt-1 text-sm" v-if="errors['cost_volume_small']">{{ errors['cost_volume_small'] }}</div>
        </transition>
      </div>
      <div class="mb-6">
        <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Harga Dimensi Menengah</label>
        <div class="relative">
          <TextField type="number" withIcon v-model.number="payloads.cost_volume_medium" placeholder="Harga dalam satuan rupiah" />
          <div class="absolute left-3 top-1/2 transform -translate-y-1/2">
            Rp
          </div>
        </div>
        <span class="text-xs text-gray-500 leading-tight inline-block mt-1">Ukuran yang telah ditetapkan yaitu: 30x22x12 cm</span>
        <transition name="fade" mode="out-in">
          <div class="text-system-error text-left mt-1 text-sm" v-if="errors['cost_volume_medium']">{{ errors['cost_volume_medium'] }}</div>
        </transition>
      </div>
      <div class="mb-6">
        <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Harga Dimensi Besar</label>
        <div class="relative">
          <TextField type="number" withIcon v-model.number="payloads.cost_volume_large" placeholder="Harga dalam satuan rupiah" />
          <div class="absolute left-3 top-1/2 transform -translate-y-1/2">
            Rp
          </div>
        </div>
        <span class="text-xs text-gray-500 leading-tight inline-block mt-1">Ukuran yang telah ditetapkan yaitu: 35x30x25 cm</span>
        <transition name="fade" mode="out-in">
          <div class="text-system-error text-left mt-1 text-sm" v-if="errors['cost_volume_large']">{{ errors['cost_volume_large'] }}</div>
        </transition>
      </div>
      <div class="mb-6">
        <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Estimasi Waktu Pengiriman</label>
        <div class="flex justify-between gap-6 items-center">
          <div class="flex-1">
            <TextField type="number" v-model="est_delivery_time_range_min" placeholder="Waktu minimum (cth: 24)" />
            <span class="text-xs text-gray-500 leading-tight inline-block mt-1">Dalam Jam</span>
            <transition name="fade" mode="out-in">
              <div class="text-system-error text-left mt-1 text-sm" v-if="errors['est_delivery_time_range_min']">{{ errors['est_delivery_time_range_min'] }}</div>
            </transition>
          </div>
          <div class="flex-1">
            <TextField type="number" v-model="est_delivery_time_range_max" placeholder="Waktu maximum (cth: 48)" />
            <span class="text-xs text-gray-500 leading-tight inline-block mt-1">Dalam Jam</span>
            <transition name="fade" mode="out-in">
              <div class="text-system-error text-left mt-1 text-sm" v-if="errors['est_delivery_time_range_max']">{{ errors['est_delivery_time_range_max'] }}</div>
            </transition>
          </div>
        </div>
      </div>
      <div class="mb-10">
        <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Berat Barang</label>
        <div class="flex justify-between gap-6 items-center">
          <div class="flex-1">
            <TextField type="number" v-model.number="payloads.minimum_weight" placeholder="Berat minimum" />
            <span class="text-xs text-gray-500 leading-tight inline-block mt-1">Set minimum dalam kg</span>
            <transition name="fade" mode="out-in">
              <div class="text-system-error text-left mt-1 text-sm" v-if="errors['minimum_weight']">{{ errors['minimum_weight'] }}</div>
            </transition>
          </div>
          <div class="flex-1">
            <TextField type="number" v-model.number="payloads.maximum_weight" placeholder="Berat maximum" />
            <span class="text-xs text-gray-500 leading-tight inline-block mt-1">Set maximum dalam kg</span>
            <transition name="fade" mode="out-in">
              <div class="text-system-error text-left mt-1 text-sm" v-if="errors['maximum_weight']">{{ errors['maximum_weight'] }}</div>
            </transition>
          </div>
        </div>
      </div>
      <div class="text-system-error text-center mb-10 text-sm" v-if="generalError">{{ generalError }}</div>
      <div class="flex justify-end gap-6">
        <Button buttonText="Batal" type="secondary" @action="close()" :size="isMobile ? 'full' : 'regular'" />
        <Button :buttonText="isEditMode ? 'Update' : 'Simpan'" type="primary" @action="save()" :size="isMobile ? 'full' : 'regular'" />
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import { isNotEmptyError } from '@/util/form-validator'
const CONFIG = {
  origin_city: 'Kota Asal',
  destination_city: 'Kota Tujuan',
  est_delivery_time_range_min: 'Estimasi Minumum Waktu Pengiriman',
  est_delivery_time_range_max: 'Estimasi Maximum Waktu Pengiriman',
  cost_per_weight: 'Harga Per 1 Kg',
  cost_volume_small: 'Harga Dimensi Kecil',
  cost_volume_medium: 'Harga Dimensi Menengah',
  cost_volume_large: 'Harga Dimensi Besar',
  minimum_weight: 'Berat Minimum',
  maximum_weight: 'Berat Maximum',
  base_cost: 'Komponen Harga'
}
export default {
  components: {
    TextField: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/TextField'),
    Button: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/Button'),
    Search: () => import(/* webpackChunkName: "icon" */ '@/components/Icons/Search')
  },
  props: {
    partnerId: String,
    costMappingId: String,
    isEditMode: Boolean,
    baseCostId: String
  },
  data() {
    return {
      debounce: null,
      errors: [],
      generalError: null,
      origin: '',
      originSearch: '',
      destination: '',
      destinationSearch: '',
      cityKeyword: null,
      visibleSuggestion: {
        origin: false,
        destination: false
      },
      isSearching: {
        origin: false,
        destination: false
      },
      payloads: {
        origin_city: null,
        destination_city: null,
        est_delivery_time_range_min: null,
        est_delivery_time_range_max: null,
        cost_per_weight: null,
        cost_volume_small: null,
        cost_volume_medium: null,
        cost_volume_large: null,
        minimum_weight: null,
        maximum_weight: null,
        base_cost: null
      },
      est_delivery_time_range_min: null,
      est_delivery_time_range_max: null
    }
  },
  watch: {
    est_delivery_time_range_min(val) {
      if (val) {
        this.payloads.est_delivery_time_range_min = val + 'h'
      }
    },
    est_delivery_time_range_max(val) {
      if (val) {
        this.payloads.est_delivery_time_range_max = val + 'h'
      }
    }
  },
  mounted() {
    if (this.isEditMode) {
      this.getBaseCostInfo()
    }
  },
  computed: {
    ...mapGetters('master', ['cities']),
    ...mapGetters('common', ['isMobile']),
    ...mapGetters('partner', ['baseCostDetail'])
  },
  methods: {
    ...mapActions('master', ['getCities']),
    ...mapActions('partner', ['createBaseCost', 'getBaseCostDetail', 'updateBaseCost']),
    ...mapActions('common', ['showLoading', 'hideLoading', 'setToast']),
    getBaseCostInfo() {
      this.showLoading()
      this.getBaseCostDetail({
        partnerId: this.partnerId,
        costMappingId: this.costMappingId,
        baseCostId: this.baseCostId
      }).then(res => {
        const result = res.data.data
        const originCityCode = result.origin_city.split('.').pop()
        const destinationCityCode = result.destination_city.split('.').pop()
        this.originSearch = `${result.origin_city_name} (${originCityCode})`
        this.destinationSearch = `${result.destination_city_name} (${destinationCityCode})`
        this.est_delivery_time_range_min = result.est_delivery_time_range_min.replace('h', '')
        this.est_delivery_time_range_max = result.est_delivery_time_range_max.replace('h', '')
        this.payloads = {
          origin_city: result.origin_city,
          destination_city: result.destination_city,
          cost_per_weight: result.cost_per_weight,
          cost_volume_small: result.cost_volume_small,
          cost_volume_medium: result.cost_volume_medium,
          cost_volume_large: result.cost_volume_large,
          minimum_weight: result.minimum_weight,
          maximum_weight: result.maximum_weight,
          base_cost: result.base_cost
        }
        this.hideLoading()
      })
    },
    validForm() {
      const error = isNotEmptyError(this.payloads)
      this.errors = error.reduce(function(map, obj) {
        map[obj.field] = CONFIG[obj.field] + ' ' + obj.error
        return map
      }, {})
      return Object.keys(this.errors).length === 0
    },
    save() {
      if (this.validForm()) {
        if (this.isEditMode) {
          this.showLoading()
          const payload = {
            est_delivery_time_range_min: this.payloads.est_delivery_time_range_min,
            est_delivery_time_range_max: this.payloads.est_delivery_time_range_max,
            cost_per_weight: this.payloads.cost_per_weight,
            cost_volume_small: this.payloads.cost_volume_small,
            cost_volume_medium: this.payloads.cost_volume_medium,
            cost_volume_large: this.payloads.cost_volume_large,
            minimum_weight: this.payloads.minimum_weight,
            maximum_weight: this.payloads.maximum_weight,
            base_cost: this.payloads.base_cost
          }
          this.updateBaseCost({
            partnerId: this.partnerId,
            costMappingId: this.costMappingId,
            baseCostId: this.baseCostId,
            payloads: payload
          })
            .then(() => {
              this.hideLoading()
              this.setToast({
                options: { type: 'success', duration: 1000, primaryText: 'Base Cost Berhasil Diubah', secondaryText: 'Data telah kami simpan', callback: this.handleCallback }
              })
            })
            .catch(() => {
              this.hideLoading()
              this.generalError = 'Terjadi kesalahan pada sistem. Silakan coba lagi'
            })
        } else {
          this.showLoading()
          this.createBaseCost({
            partnerId: this.partnerId,
            costMappingId: this.costMappingId,
            payloads: this.payloads
          })
            .then(() => {
              this.hideLoading()
              this.setToast({
                options: { type: 'success', duration: 1000, primaryText: 'Penambahan Base Cost Berhasil', secondaryText: 'Data telah kami simpan', callback: this.handleCallback }
              })
            })
            .catch(() => {
              this.hideLoading()
              this.generalError = 'Terjadi kesalahan pada sistem. Silakan coba lagi'
            })
        }
      } else {
        this.generalError = 'Pastikan Anda telah memasukan semua data yang dibutuhkan!'
      }
    },
    handleCallback() {
      this.$emit('refetch')
    },
    close() {
      this.$emit('close')
    },
    searchCity(value, target) {
      this.cityKeyword = null
      this.isSearching[target] = true
      this.visibleSuggestion[target] = false
      clearTimeout(this.debounce)
      this.debounce = setTimeout(() => {
        this.cityKeyword = value
        this.getCities({
          params: {
            page: 1,
            per_page: 1000,
            search_keyword: this.cityKeyword
          }
        }).then(() => {
          this.visibleSuggestion[target] = true
          this.isSearching[target] = false
        })
      }, 200)
    },
    selectCity(data, target) {
      if (target === 'origin') {
        this.payloads.origin_city = data.code
        this.originSearch = `${data.village}, ${data.area_display}`
      } else {
        this.payloads.destination_city = data.code
        this.destinationSearch = `${data.village}, ${data.area_display}`
      }
      this.visibleSuggestion[target] = false
    }
  }
}
</script>
<style lang="scss" scoped>
.currency {
  &::v-deep input {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
    padding-left: 0.75rem;
    padding-right: 0.75rem;
    border-radius: 0.5rem;
    border-color: rgba(206, 213, 222, 1);
    border-width: 1px;
    border-style: solid;
    width: 100%;
    outline: none;
  }
}
</style>
